import DeviceInterface, { DeviceNetworkProps } from '@/interfaces/models/device';

export default class DeviceNetwork implements DeviceInterface {
  public image: URL = new URL('https://i.mt.lv/cdn/rb_images/1413_m.png');
  public role: string = 'System AP';
  public description: string = '';
  public deviceType: number;
  public fields: any[];
  public id: string;
  public ip: string;
  public name: string;
  public password: string;
  public ssid: number;
  public wiFiPassword: string;

  [key: string]: any;

  public constructor(deviceNetworkProps: DeviceNetworkProps) {
    this.description = deviceNetworkProps.description;
    this.deviceType = deviceNetworkProps.deviceType;
    this.fields = deviceNetworkProps.fields;
    this.id = deviceNetworkProps.id;
    this.ip = deviceNetworkProps.ip;
    this.name = deviceNetworkProps.name;
    this.password = deviceNetworkProps.password;
    this.ssid = deviceNetworkProps.ssid;
    this.wiFiPassword = deviceNetworkProps.wiFiPassword;
  }
}
